import React,{ useState, useEffect } from 'react';
import MaterialTable from 'material-table';
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { api } from 'common';
import { useTranslation } from "react-i18next";
import {colors} from '../components/Theme/WebTheme';
import {  useNavigate ,useLocation} from 'react-router-dom';
import AlertDialog from '../components/AlertDialog';
import BlankTable from 'components/BlankTable';

export default function Notifications() {
  const { t, i18n  } = useTranslation();
  const isRTL = i18n.dir();
  const {editNotifications  } = api;
  const settings = useSelector(state => state.settingsdata.settings);
  const {state}=useLocation();

  const columns =  [
      {
        title: t('device_type'),
        field: 'devicetype',
        lookup: { All: (t('all')), ANDROID: (t('android')), IOS: (t('ios')) },
      },
      {
        title: t('user_type'),
        field: 'usertype',
        lookup: { customer: t('customer'), driver: t('driver') },
      },
      { title: t('title'),field: 'title', },
      { title: t('body'), field: 'body', },
  ];

  const [data, setData] = useState([]);
  const notificationdata = useSelector(state => state.notificationdata);
  const dispatch = useDispatch();

  useEffect(()=>{
        if(notificationdata.notifications){
            setData(notificationdata.notifications.map(notification => ({...notification})));
        }else{
            setData([]);
        }
  },[notificationdata.notifications]);

  const [selectedRow, setSelectedRow] = useState(null);

  const [commonAlert, setCommonAlert] = useState({ open: false, msg: '' });

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: '' })
  };

  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(0); 

  useEffect(()=>{
   setCurrentPage(state?.pageNo)
  },[state])


const handlePaginationChange = (page) => {
  setCurrentPage(page)
};

const options={
  initialPage:state?.pageNo ||0,
  pageSize: 10,
  pageSizeOptions: [10, 15, 20],
  rowStyle: rowData => ({
    backgroundColor: (selectedRow === rowData.tableData.id) ?  colors.THIRDCOLOR: colors.WHITE
  }),
  editable:{
    backgroundColor: colors.WHITE,
    fontSize: "0.8em",
    fontWeight: 'bold ',
    fontFamily: 'Lucida Console", "Courier New", monospace'
  },
  headerStyle: {
    position: "sticky",
    top: "0px",
    backgroundColor: colors.SECONDARY,
    color: colors.WHITE,
    fontSize: "0.8em",
    fontWeight: 'bold ',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    border: `1px solid rgba(224, 224, 224, 1)`,
    textAlign: "center",
    minWidth:"60px"
  },
  cellStyle: {
    border: `1px solid rgba(224, 224, 224, 1)`,
    textAlign: "center",
  },
  actionsColumnIndex: -1,
}
const localization={body:{
  addTooltip: (t('add')),
  deleteTooltip: (t('delete')),
  editTooltip: (t('edit')),
  emptyDataSourceMessage: (
    (t('blank_message'))
),
editRow: { 
  deleteText: (t('delete_message')),
  cancelTooltip: (t('cancel')),
  saveTooltip: (t('save')) 
  }, 
  },
  toolbar: {
    searchPlaceholder: (t('search')),
    exportTitle: (t('export')),
  },
  header: {
    actions: (t('actions')) 
},
pagination: {
  labelDisplayedRows: ('{from}-{to} '+ (t('of'))+ ' {count}'),
  firstTooltip: (t('first_page_tooltip')),
  previousTooltip: (t('previous_page_tooltip')),
  nextTooltip: (t('next_page_tooltip')),
  lastTooltip: (t('last_page_tooltip'))
},
}
  return (
    notificationdata.loading? <CircularLoading/>:
    <> {data && data.length > 0 ? 
    <MaterialTable
      title={t('push_notification_title')}
      onChangePage={(page) => handlePaginationChange(page)}
      columns={columns}
      style={{direction:isRTL ==='rtl'?'rtl':'ltr', borderRadius: "8px", boxShadow: "4px 4px 6px #9E9E9E"}}
      data={data}
      onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
      options={options}
      localization={localization}
      editable={{
        onRowDelete: oldData => settings.AllowCriticalEditsAdmin ?
          new Promise(resolve => {
            setTimeout(() => {
              resolve();
              dispatch(editNotifications(oldData,"Delete"));
            }, 600);
          }) :
          new Promise(resolve => {
            setTimeout(() => {
              resolve();
              setCommonAlert({ open: true, msg: t('demo_mode') });
            }, 600);
          })
      ,
      }}

      actions={[
        {
          icon: 'add',
          tooltip: t("add_notification"),
          isFreeAction: true,
          onClick: (event) => 
          navigate( `/notifications/addnotifications`,  { state: { pageNo: currentPage }} )
        },
      ]}
    />: <BlankTable  title={t('push_notification_title')}  columns={columns}  data={[]} options={options}
    localization={localization}  
    actions={[   
      {
        icon: 'add',
        tooltip: t("add_notification"),
        isFreeAction: true,
        onClick: (event) => 
        navigate( `/notifications/addnotifications`,  { state: { pageNo: currentPage }} )
      },
    ]}
  />}
    <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>{commonAlert.msg}</AlertDialog>
  </>
  );
}
